import React from 'react';
import { Tooltip } from 'antd';
import { MetaTagsListContainer, MetaTagChip, MetaTagText } from './styles';

const MetaTagsList = ({ metaTags = [], onDelete, disabled = false }) => {
  if (!metaTags || metaTags.length === 0) {
    return null;
  }

  return (
    <MetaTagsListContainer>
      {metaTags.map((metaTag) => {
        const displayText = `${metaTag.key}: ${metaTag.value}`;
        const isLongText = displayText.length > 30;
        
        const tagContent = (
          <MetaTagChip
            closable={!disabled}
            onClose={() => onDelete(metaTag.id || metaTag.key)}
            key={metaTag.id || `${metaTag.key}-${metaTag.value}`}
          >
            <MetaTagText>
              {isLongText ? `${displayText.slice(0, 30)}...` : displayText}
            </MetaTagText>
          </MetaTagChip>
        );

        return isLongText ? (
          <Tooltip title={displayText} key={metaTag.id || `${metaTag.key}-${metaTag.value}`}>
            {tagContent}
          </Tooltip>
        ) : (
          tagContent
        );
      })}
    </MetaTagsListContainer>
  );
};

export default MetaTagsList;

